import { gql } from '@apollo/client';

export default gql`
  mutation CreateProducerUserMutation($producerUser: ProducerUserInput!) {
    createProducerUser(input: { producerUser: $producerUser }) {
      producerUser {
        id
      }
    }
  }
`;
